<template>
	<page>
		<template v-if="!openModal">
			<v-row align="center" justify="center" >
				<v-card width="600">
					<v-col cols="12">
						<v-card-text class="text-center display-1"> {{notification.title}}</v-card-text>
						<v-card-text class="text-center">{{notification.content}} </v-card-text>
						<v-img :src="notification.image[0]" />
						<v-card-actions v-if="isManager"><v-btn color="primary" @click="openEdit(notification)">ערוך</v-btn></v-card-actions>
					</v-col>
				</v-card>
			</v-row>
		</template>
		<template v-if="openModal">
			<notification-form v-if="openModal" @save="sendEvent"/>
		</template>
	</page>
</template>

<script>
	import NotificationsModule from "../../store/modules/Notification.module";
	import NotificationForm from "./NotificationForm.vue";
	export default {
		name: "notifications-view",
		components: {NotificationForm},
		data() {
			return {
				openModal: null,
			};
		},
		computed: {
			notification() {
				return this.$store.state.NotificationModule.notifications[0];
			},
			isManager() {
				return this.$store.getters.isManager;
			},
		},
		methods: {
			openEdit(obj){
				this.$store.commit(NotificationsModule.types.GET,obj || {});
				this.openModal = true;
			},
			sendEvent(){
				this.openModal = false;
				this.$emit("save");
			}
		},
		async created() {
			let res = await this.$store.dispatch(NotificationsModule.types.FETCH);
			if(Object.keys(res).length > 0){
				this.openModal = false;
			}else{
				this.openModal = true;
			}
		},
	};
</script>

<style scoped></style>
